module.exports = __webpack_public_path__ + "static/media/Office Map_zones_new colors 1.c9ee6244.jpg";